/* ============================================
   Seek Key — Cart Dropdown JS
   Replaces the native cart drawer with a compact dropdown.
   ============================================ */

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.onBodyClick = this.handleBodyClick.bind(this);
    /* Esc fecha mesmo que o foco não esteja dentro do <cart-drawer>:
       o gatilho (#cart-icon-bubble) vive no header, fora desta subárvore,
       então um listener no próprio elemento nunca recebia o Esc. Ouvir no
       document (guardado por .active) garante o fechamento por teclado. */
    this.onKeydown = (evt) => {
      if (evt.key === 'Escape' && this.classList.contains('active')) this.close();
    };
    document.addEventListener('keydown', this.onKeydown);
    this.bindCartIcon();
  }

  bindCartIcon() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggle(cartLink);
    });
  }

  toggle(triggeredBy) {
    if (this.classList.contains('active')) {
      this.close();
    } else {
      this.open(triggeredBy);
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    /* Close account dropdown if open */
    var accountDD = document.getElementById('sk-account-dropdown');
    if (accountDD) accountDD.classList.remove('sk-dd-show');
    this.positionDropdown();
    this.classList.add('active');
    document.body.addEventListener('click', this.onBodyClick);
    if (window.innerWidth < 750) {
      document.body.classList.add('overflow-hidden');
    }
    /* a11y: leva o foco pra dentro do painel — assim teclado/leitor de tela
       entram no carrinho ao abrir (e Esc/Tab passam a operar aqui dentro). */
    var panel = this.querySelector('.sk-cart-dropdown__panel');
    if (panel) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-label', 'Carrinho');
      panel.setAttribute('tabindex', '-1');
      requestAnimationFrame(function () { panel.focus(); });
    }
  }

  close() {
    /* Só devolve o foco pro gatilho se ele estava DENTRO do carrinho
       (fechou por Esc ou pelo X). Se o usuário clicou fora, não roubar
       o foco de onde ele foi. */
    var focusWasInside = this.contains(document.activeElement);
    this.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');
    if (focusWasInside) {
      var trigger = this.activeElement || document.querySelector('#cart-icon-bubble');
      if (trigger && typeof trigger.focus === 'function') trigger.focus();
    }
  }

  positionDropdown() {
    const icon = document.querySelector('#cart-icon-bubble');
    const panel = this.querySelector('.sk-cart-dropdown__panel');
    if (!icon || !panel) return;

    if (window.innerWidth < 750) {
      panel.style.position = 'fixed';
      panel.style.top = 'auto';
      panel.style.right = '0';
      panel.style.bottom = '0';
      panel.style.left = '0';
      panel.style.maxWidth = '100%';
      /* vh no mobile = viewport GRANDE (barra de URL recolhida): com o carrinho
         cheio, 85vh passava de 95% da área realmente visível. dvh mede o que
         está na tela agora. Navegador sem dvh ignora a 2ª linha e fica no vh. */
      panel.style.maxHeight = '85vh';
      panel.style.maxHeight = '85dvh';
      panel.style.borderRadius = '8px 8px 0 0';
      return;
    }

    var rect = icon.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.top = (rect.bottom + 8) + 'px';
    panel.style.right = Math.max(16, window.innerWidth - rect.right - 8) + 'px';
    panel.style.bottom = 'auto';
    panel.style.left = 'auto';
    panel.style.maxWidth = '420px';
    panel.style.maxHeight = 'calc(100vh - ' + (rect.bottom + 24) + 'px)';
    panel.style.borderRadius = '18px';
  }

  /* renderContents is called by product-form.js after a successful add-to-cart.
     parsedState.sections contains pre-rendered HTML from Shopify's Section Rendering API.
     This is safe HTML generated server-side by Shopify (not user input). */
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(function(section) {
      var sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      /* Section Rendering API returns trusted Shopify-rendered HTML */
      var parsed = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
      var source = parsed.querySelector(section.selector || '.shopify-section');
      if (source) {
        sectionElement.replaceChildren();
        while (source.firstChild) {
          sectionElement.appendChild(source.firstChild);
        }
      }
    });

    if (this.classList.contains('is-empty')) {
      this.classList.remove('is-empty');
    }
    var drawerItems = this.querySelector('cart-drawer-items');
    if (drawerItems && drawerItems.classList.contains('is-empty')) {
      drawerItems.classList.remove('is-empty');
    }

    var self = this;
    setTimeout(function() {
      /* Mobile: NÃO sequestrar a tela a cada item adicionado.
         O painel come ~500px + trava o scroll do body — o cliente estava
         navegando e era jogado num modal que só se fecha com um toque a mais.
         Agora confirma com um toast ancorado no ícone e a navegação segue.
         Desktop mantém o dropdown (360px preso ao ícone, não bloqueia nada). */
      if (window.innerWidth < 750) {
        self.showAddedToast(parsedState);
      } else {
        self.open();
      }
    });
  }

  /* Confirmação leve pós-adicionar (mobile).
     parsedState vem do /cart/add.js: traz product_title e image do item. */
  showAddedToast(item) {
    var self = this;
    var existing = document.querySelector('.sk-cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'sk-cart-toast';
    toast.setAttribute('role', 'status');

    if (item && item.image) {
      var img = document.createElement('img');
      /* CDN da Shopify aceita ?width= — evita baixar a capa em tamanho cheio */
      img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      img.alt = '';
      img.width = 56;
      img.height = 32;
      img.className = 'sk-cart-toast__img';
      /* capa que não carregar some, em vez de virar ícone de imagem quebrada */
      img.addEventListener('error', function () { img.remove(); });
      toast.appendChild(img);
    }

    var text = document.createElement('div');
    text.className = 'sk-cart-toast__text';
    var title = document.createElement('span');
    title.className = 'sk-cart-toast__title';
    /* textContent: título de produto nunca vira HTML */
    title.textContent = (item && item.product_title) || 'Jogo digital';
    var sub = document.createElement('span');
    sub.className = 'sk-cart-toast__sub';
    sub.textContent = 'adicionado ao carrinho';
    text.appendChild(title);
    text.appendChild(sub);
    toast.appendChild(text);

    var action = document.createElement('button');
    action.type = 'button';
    action.className = 'sk-cart-toast__action';
    action.textContent = 'Ver';
    action.setAttribute('aria-label', 'Ver carrinho');
    toast.appendChild(action);

    /* Ancora logo abaixo do ícone do carrinho: liga visualmente o toast ao
       contador que acabou de subir (e não depende da altura do header). */
    var icon = document.querySelector('#cart-icon-bubble');
    if (icon) {
      var rect = icon.getBoundingClientRect();
      toast.style.top = Math.max(12, rect.bottom + 10) + 'px';
      icon.classList.add('sk-cart-bump');
      setTimeout(function () { icon.classList.remove('sk-cart-bump'); }, 600);
    }

    document.body.appendChild(toast);

    var timer = setTimeout(function () {
      if (toast.parentNode) toast.remove();
    }, 4000);

    action.addEventListener('click', function (evt) {
      /* Sem stopPropagation o clique chega no body logo depois do open() e
         o handleBodyClick fecharia o painel na hora. */
      evt.stopPropagation();
      clearTimeout(timer);
      toast.remove();
      self.open(icon || undefined);
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    selector = selector || '.shopify-section';
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionDOM(html, selector) {
    selector = selector || '.shopify-section';
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  handleBodyClick(evt) {
    var target = evt.target;
    if (target.closest('.sk-cart-dropdown__panel')) return;
    if (target.closest('#cart-icon-bubble')) return;
    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.sk-cart-dropdown__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* /cart page redirect to homepage */
(function() {
  if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
    window.location.replace('/');
  }
})();
